import * as Yup from 'yup';

const login = Yup.object().shape({
  password: Yup.string().required('Password is required'),
  email: Yup.string().required('Email is required')
});

export default login;
